import crudmaker from '@/store/crudmaker'
import { apiClient } from '@/client'
import moment from 'moment'
import merge from 'deepmerge'
import { setStatus } from '@/utils'

const module = 'incidents'
let doc = {
  list: {
    hasMap: true,
    name: 'Incidents',
    headers: [
      { label: 'Code', value: 'board.code' },
      { label: 'Panneau', value: 'board.adress' },
      { label: 'District', value: 'board.district.name' },
      { label: 'Ville', value: 'board.district.city.name' },
      { label: 'Region', value: 'board.district.city.region.name' },
      { label: 'Type', value: 'incident_type.name' },
      { label: 'Responsable', value: 'user.username' },
      { label: 'Début', value: 'dateUp', orig: 'date_open', card: false },
      { label: 'Fin', value: 'dateDown', orig: 'date_close', card: false },
      { label: 'Statut', value: 'status.name', card: false },
      { label: 'Dates', value: 'dates', sortable: false, inTable: false, inDetail: false },
    ],
    dataActions: [
      { icon: 'visibility', dispatch: `${module}/goTo` },
    ],
    selectActions: [
      {
        label: 'Supprimer',
        icon: 'delete',
        scope: ['incidents.delete'],
        dispatch: `${module}/batchDelete`,
        context: {confirm: true},
        menu: true,
      },
    ],
    actions: [
      { icon: 'add', isFlat: false, scope: ['incidents.create'], dispatch: `${module}/openForm` },
      { icon: 'search', isFlat: true, dispatch: `${module}/openSearch` },
    ],
    search: [
      { label: 'Du', type: 'date', name: 'from', classes: 'md4' },
      { label: 'Au', type: 'date', name: 'to', classes: 'md4' },
      {
        label: 'Statut',
        type: 'multilist',
        from: 'name',
        name: 'status_id',
        source: 'statuses',
        context: {params: {'status_type_id': 5}},
        classes: 'md4',
      },
    ],
  },

  form: {
    name: 'Incident',
    fields: [
      {
        label: 'Panneau',
        type: 'list',
        from: 'code',
        name: 'board_id',
        source: 'boards',
      },
      {
        label: 'Type',
        type: 'list',
        from: 'name',
        name: 'incident_type_id',
        source: 'incidenttypes',
      },
      { label: 'Description', type: 'text', name: 'description' },
      {
        label: 'Intervention',
        type: 'list',
        from: 'name',
        name: 'intervention_type_id',
        source: 'interventiontypes',
      },
      { label: 'Responsable', type: 'list', from: 'username', name: 'user_id', source: 'users' },
      { label: 'Début', type: 'date', name: 'date_open' },
      { label: 'Fin', type: 'date', name: 'date_close' },
    ],
    actions: [
      { icon: 'save', filter: {edit: true}, dispatch: `${module}/update` },
      { label: 'En instance', icon: 'report_problem', filter: {status_id: 14}, dispatch: `${module}/setPending` },
      { label: 'Archiver', icon: 'delete', filter: {status_id: 14}, dispatch: `${module}/delete` },
      { label: 'Réglé', icon: 'check_circle', filter: {status_id: 13}, dispatch: `${module}/setFixed` },
      {
        icon: 'delete',
        scope: ['incidents.delete'],
        isFlat: true,
        dispatch: `${module}/delete`,
        context: { confirm: true },
      },
    ],
    relations: [],
  },

  postprocess: item => {
    let dateUp = moment(item.date_open).format('DD/MM/YYYY')
    let dateDown = item.date_close !== null ? moment(item.date_close).format('DD/MM/YYYY') : ''
    let position = item.board ? {lng: parseFloat(item.board.lon), lat: parseFloat(item.board.lat)} : undefined
    return {
      ...item,
      dateUp,
      dateDown,
      dates: `${dateUp} - ${dateDown}`,
      position,
    }
  },

  params: {
    fetchAll: {include: 'incident_type,intervention_type,user,status,board.board_type,board.district.city.region'},
    fetchOne: {include: 'incident_type,intervention_type,user,status,board.board_type'},
  },
}

const base = crudmaker(module, apiClient, doc)

const custom = {
  actions: {
    setFixed: ({ commit, dispatch }, payload) => setStatus(apiClient, module, commit, dispatch, payload, 'fixed'),
    setPending: ({ commit, dispatch }, payload) => setStatus(apiClient, module, commit, dispatch, payload, 'pending'),
  },
}
export default merge(base, custom)
